import { cn } from '@gestao/ui'
import { CircleAlert } from 'lucide-react'
import type { ReactNode } from 'react'

interface FormAlertProps {
  children: ReactNode
  className?: string
}

/**
 * Erro do formulário inteiro (bloqueio, sem conexão, limite de tentativas). Erros de campo
 * ficam abaixo do campo, no FormField. `role="alert"` anuncia assim que aparece.
 */
export function FormAlert({ children, className }: FormAlertProps) {
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2 rounded-md border border-framboesa/40 bg-framboesa/8 px-3 py-2.5 text-compact text-ink',
        className,
      )}
    >
      <CircleAlert aria-hidden className="mt-px size-4 shrink-0 text-framboesa" />
      <p>{children}</p>
    </div>
  )
}
